import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from 'helpers/api_helper';

function* fetchClaimDropdownSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_EXTRA_DUTY_CLAIM_DROPDOWN, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Claim Dropdown Lists!');
    }

    yield put({ type: types.FETCH_CLAIM_DROPDOWN_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_CLAIM_DROPDOWN_FAILURE, payload: error });
  }
}

function* saveExtraDutyClaimSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_EXTRA_DUTY_CLAIM,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Extra Duty Claim!");
    }

    yield put({ type: types.SAVE_EXTRA_DUTY_CLAIM_SUCCESS, payload: response });

    Swal.fire("Success", response?.message, "success");
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_EXTRA_DUTY_CLAIM_FAILURE, payload: error });
  }
}

function* saveExtraDutyApprovalSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_EXTRA_DUTY_APPROVAL,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Extra Duty Approvals!");
    }

    yield put({ type: types.SAVE_EXTRA_DUTY_APPROVAL_SUCCESS, payload: response });

    Swal.fire("Success", response?.message || "Approvals saved successfully!", "success");
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving Approvals!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_EXTRA_DUTY_APPROVAL_FAILURE, payload: error });
  }
}

function* fetchExtraDutyApprovalDetailListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_APPROVAL_DETAIL_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Approval Detail List!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_FAILURE, payload: error });
  }
}

function* fetchExtraDutyApprovalsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXTRA_DUTY_APPROVALS, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Extra Duty Approvals!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_APPROVALS_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_APPROVALS_FAILURE, payload: error });
  }
}

function* fetchPunchDetailsSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_EXTRA_PUNCH_DETAILS,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Punch Details!");
    }

    yield put({ type: types.FETCH_PUNCH_DETAILS_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_PUNCH_DETAILS_FAILURE, payload: error });
  }
}

// Save Cancel
function* saveExtraDutyCancelSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EXTRA_DUTY_CANCEL, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Extra Duty Cancel!");
    }

    yield put({ type: types.SAVE_EXTRA_DUTY_CANCEL_SUCCESS, payload: response });

    Swal.fire("Success", response?.message || "Cancel saved successfully!", "success");
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving Cancel!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_EXTRA_DUTY_CANCEL_FAILURE, payload: error });
  }
}

// Fetch Cancel Detail List
function* fetchExtraDutyCancelDetailListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_CANCEL_DETAIL_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Cancel Detail List!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_FAILURE, payload: error });
  }
}

// Fetch Cancels (List)
function* fetchExtraDutyCancelsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_CANCEL, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Extra Duty Cancels!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_CANCELS_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_CANCELS_FAILURE, payload: error });
  }
}

function* fetchExtraDutyPaymentClaimListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_PAYMENT_CLAIM_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Extra Duty Payment Claim List!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_FAILURE, payload: error });
  }
}

// 🔹 Convert Payment
function* convertPaymentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_CONVERT_PAYMENT, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to convert payment!");
    }

    yield put({ type: types.CONVERT_PAYMENT_SUCCESS, payload: response });
    Swal.fire("Success", response?.message || "Payment Claim Saved Successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.CONVERT_PAYMENT_FAILURE, payload: error });
  }
}

// ✅ Fetch Approval List
function* fetchExtraDutyPaymentClaimApprovalListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Approval List!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_FAILURE, payload: error });
  }
}

// ✅ Fetch Cancel List
function* fetchExtraDutyPaymentClaimCancelListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Cancel List!");
    }

    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_FAILURE, payload: error });
  }
}

// ✅ Cancel Payment
function* cancelPaymentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CANCEL_PAYMENT, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to cancel payment!");
    }

    yield put({ type: types.CANCEL_PAYMENT_SUCCESS, payload: response });
    Swal.fire("Success", response?.message || "Payment Cancelled Successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.CANCEL_PAYMENT_FAILURE, payload: error });
  }
}

// ✅ Fetch Manual Punch List
function* fetchManualPunchListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_MANUAL_PUNCH_LIST, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch Manual Punch List!");
    }

    yield put({ type: types.FETCH_MANUAL_PUNCH_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_MANUAL_PUNCH_LIST_FAILURE, payload: error });
  }
}

// ✅ Save Manual Punch
function* saveManualPunchSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MANUAL_PUNCH, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Manual Punch!");
    }

    yield put({ type: types.SAVE_MANUAL_PUNCH_SUCCESS, payload: response });
    Swal.fire("Success", response?.message || "Manual Punch Saved Successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.SAVE_MANUAL_PUNCH_FAILURE, payload: error });
  }
}

// ✅ Delete Manual Punch
function* deleteManualPunchSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_MANUAL_PUNCH, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to delete Manual Punch!");
    }

    yield put({ type: types.DELETE_MANUAL_PUNCH_SUCCESS, payload: response });
    Swal.fire("Success", response?.message || "Manual Punch Deleted Successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.DELETE_MANUAL_PUNCH_FAILURE, payload: error });
  }
}

export default function* claimDropdownSagas() {
  yield takeLatest(types.FETCH_CLAIM_DROPDOWN_REQUEST, fetchClaimDropdownSaga);
  yield takeLatest(types.SAVE_EXTRA_DUTY_CLAIM_REQUEST, saveExtraDutyClaimSaga);

  yield takeLatest(types.SAVE_EXTRA_DUTY_APPROVAL_REQUEST, saveExtraDutyApprovalSaga);
  yield takeLatest(types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_REQUEST, fetchExtraDutyApprovalDetailListSaga);
  yield takeLatest(types.FETCH_EXTRA_DUTY_APPROVALS_REQUEST, fetchExtraDutyApprovalsSaga);
  yield takeLatest(types.FETCH_PUNCH_DETAILS_REQUEST, fetchPunchDetailsSaga);

  yield takeLatest(types.SAVE_EXTRA_DUTY_CANCEL_REQUEST, saveExtraDutyCancelSaga);
  yield takeLatest(types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_REQUEST, fetchExtraDutyCancelDetailListSaga);
  yield takeLatest(types.FETCH_EXTRA_DUTY_CANCELS_REQUEST, fetchExtraDutyCancelsSaga);

  yield takeLatest(types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_REQUEST, fetchExtraDutyPaymentClaimListSaga);
  yield takeLatest(types.CONVERT_PAYMENT_REQUEST, convertPaymentSaga);

  yield takeLatest(types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_REQUEST, fetchExtraDutyPaymentClaimApprovalListSaga);
  yield takeLatest(types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_REQUEST, fetchExtraDutyPaymentClaimCancelListSaga);
  yield takeLatest(types.CANCEL_PAYMENT_REQUEST, cancelPaymentSaga);

  yield takeLatest(types.FETCH_MANUAL_PUNCH_LIST_REQUEST, fetchManualPunchListSaga);
  yield takeLatest(types.SAVE_MANUAL_PUNCH_REQUEST, saveManualPunchSaga);
  yield takeLatest(types.DELETE_MANUAL_PUNCH_REQUEST, deleteManualPunchSaga);

}
